import type { Practitioner } from "@medplum/fhirtypes";
import { PRACTITIONER_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

/**
 * Hook that subscribes to Practitioner resource changes via WebSocket
 * and updates the TanStack DB collection in real-time.
 *
 * Must be used inside FhirDataStoreProvider.
 */
export const usePractitionerSubscription = createSubscriptionHook<Practitioner>(
  "Practitioner",
  PRACTITIONER_COLLECTION_NAME,
);
